// ABOUTME: Authentication API calls (login, logout, me)
// ABOUTME: Interfaces with FastAPI /api/auth/* endpoints

import { apiClient } from './client'
import type { LoginRequest, LoginResponse, User } from '@/types/api'

export const authApi = {
  /**
   * Login user and store JWT token
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>('/api/auth/login', credentials)

    // Store token in localStorage (backup to httpOnly cookie)
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token)
    }

    return response.data
  },

  /**
   * Logout user (clears cookie + localStorage)
   */
  async logout(): Promise<void> {
    try {
      await apiClient.post('/api/auth/logout')
    } finally {
      // Always clear local storage
      localStorage.removeItem('access_token')
    }
  },

  /**
   * Get current authenticated user
   */
  async me(): Promise<User> {
    const response = await apiClient.get<User>('/api/auth/me')
    return response.data
  }
}
